export const landModel = {
    label: 'Terrain à restaurer (Mangrove)',
    tableName: 'land',
    properties: [
        {
            label: 'Surface',
            id: 'surface',
            type: 'text',
            example: '1.5', // Float dans Prisma
            required: true
        },
        {
            label: 'Classe de mangrove',
            id: 'mangrove_class',
            type: 'text',
            example: 'Mangrove dense',
            required: true
        },
        {
            label: 'Site',
            id: 'village',
            isForeignKey: true,
            column_name: 'name',
            table_column: 'site',
            type: 'text',
            example: 'Village Nord',
            required: true
        },
        {
            label: "Polygone d'étude d'état initial",
            id: 'is_recipient_polygon',
            type: 'text',
            example: 'Oui', // À convertir en Boolean (true/false) dans le backend
            required: true
        },
        {
            label: 'Couleur substrat',
            id: 'substrat_color',
            type: 'text',
            example: 'Noirâtre',
            required: true
        },
        {
            label: 'Profondeur',
            id: 'depth',
            type: 'text',
            example: '30 cm',
            required: true
        },
        {
            label: 'Texture de sol',
            id: 'soil_texture',
            type: 'text',
            example: 'Vaseuse',
            required: true
        },
        {
            label: 'Salinité ‰',
            id: 'salinity',
            type: 'text',
            example: '35',
            required: true
        },
        {
            label: 'Temps de submersion (h)',
            id: 'submers_time',
            type: 'text',
            example: '4',
            required: true
        },
        {
            label: 'Nombre de jours de submersion par mois ',
            id: 'mare_frequency',
            type: 'text',
            example: '22',
            required: true
        },
        {
            label: 'Régénération naturelle : abondance',
            id: 'abundance',
            type: 'text',
            example: 'Moyenne',
            required: true
        },
        {
            label: 'Régénération naturelle : répartition',
            id: 'repartition',
            type: 'text',
            example: 'Agrégée',
            required: true
        },
        {
            label: 'Régénération naturelle : âge',
            id: 'age',
            type: 'text',
            example: '2 ans',
            required: true
        },
        {
            label: 'Cause de dégradation',
            id: 'cause',
            type: 'text',
            example: 'Coupe de bois',
            required: true
        },
        {
            label: 'Text explicatif de dégradation',
            id: 'explanation_cause',
            type: 'text',
            example: 'Exploitation illégale pour le charbon de bois',
            required: true
        },
        {
            label: 'Année de dégradation',
            id: 'degradation_date',
            type: 'text',
            example: '2022',
            required: true
        },
        {
            label: 'Présence des maladies',
            id: 'have_desease',
            type: 'text',
            example: 'Non',
            required: true
        },
        {
            label: "Changement d'utilisation de terre",
            id: 'use_land_changement',
            type: 'text',
            example: 'Saliculture',
            required: true
        },
        {
            label: "Texte explicatif de changement d'utilisation de terre",
            id: 'explanation_use',
            type: 'text',
            example: 'Conversion ancienne en marais salant abandonné',
            required: true
        },
        {
            label: 'Note',
            id: 'note',
            type: 'text',
            example: 'Terrain à fort potentiel de restauration',
            required: true
        }
    ]
}
